export enum ScenarioState {
  NOT_STARTED = 'SCENARIO_NOT_STARTED',
  STARTED = 'SCENARIO_STARTED',
  SCENARIO_FAILED = 'SCENARIO_FAILED',
  SCENARIO_SUCCESS = 'SCENARIO_SUCCESS',
  SCENARIO_ERROR = 'SCENARIO_ERROR',
  SCENARIO_AWAITING_RESULTS = 'SCENARIO_AWAITING_RESULTS',
}

export enum ScenarioMethod {
  VIDEO = 'VIDEO',
  BANK = 'BANK',
  MOBILE_APP = 'MOBILE_APP',
  ELECTRONIC_SIGNATURE = 'ELECTRONIC_SIGNATURE',
  LOGIN_GOV = 'LOGIN_GOV',
  CHAIN = 'CHAIN',
  DECENTRALIZED_ID = 'DECENTRALIZED_ID',
}

export enum ScenarioGroup {
  NONE = 'NONE',
  OPEN_BANKING = 'OPEN_BANKING',
  BANK_EID = 'BANK_EID',
  REFUNDED_TRANSFER = 'REFUNDED_TRANSFER',
}
